import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';

import { Perfil, Respuesta, User } from '../_models/shared/_index';
import { FirebaseMessagingService } from './firebase/firebaseMessaging.service';
import { FirebaseAuthService } from './firebase/firebaseAuth.service';
import { Router } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import { contains } from 'jquery';

const ACCIONES_SISTEMA = [
	'login',
	'inicio',
	'comparacion-material',
	'ventajas-material',
];

@Injectable({
	providedIn: 'root',
})
export class SessionService {
	// Perfil
	private currentUser: User;
	private perfil;
	private acciones;
	private diccAcciones: any;
	private yubiEvent = new Subject<any>();

	private httpErrorSubject = new Subject<number>();

	private urlInicial: string;
	private urlRaiz: string = '/app';

	private eliminarPerfilbyIdSessionUrl =
		environment.rest + '/User/CerrarSesionByIdSession';
	private getAllSessionsActiveUrl =
		environment.rest + '/Session/GetSesionesActivas';
	private getSessionActiveUrl = environment.rest + '/User/GetSessionActive';
	private autenticarUsuarioUrl = environment.rest + '/User/AutenticarUsuario';
	private ingresarUrl = environment.rest + '/User/Ingresar';
	private reingresarUrl = environment.rest + '/User/Reingresar';
	private cerrarSesionUrl = environment.rest + '/User/CerrarSesion';
	private getPerfilesUrl = environment.rest + '/User/GetPerfiles';
	private validateOtpUrl = environment.rest + '/User/verificarOtp';
	private eliminarPerfilUrl = environment.rest + '/User/EliminarPerfil';
	private esCambioDePerfilUrl = environment.rest + '/User/EsCambioDePerfil';
	private getDiccionarioAccionesUrl =
		environment.rest + '/User/GetDiccionarioAcciones';
	private getDiccionarioVariablesLocalesUrl =
		environment.rest + '/User/GetDiccionarioVariablesLocalesUsuario';
	private getFirebaseAuthUrl = environment.rest + '/User/GetFirebaseAuth';
	private obtenerUrlComparadorUrl =
		environment.rest + '/User/ObtenerUrlComparador';
	private getIdiomasUrl = environment.rest + '/User/GetIdiomas';
	private logMovimientoUrl = environment.rest + '/User/LogMovimiento';
	private getAccessTokenUrl = environment.rest + '/Scraping/GetAccessToken';
	private getStrClientesUrl = environment.rest + '/Clientes/GetStrClientes';

	private getTokenInternoUrl = environment.rest + '/User/ObtenerTokenInterno';

	constructor(
		private http: HttpClient,
		private firebaseMessagingService: FirebaseMessagingService,
		private firebaseAuthService: FirebaseAuthService,
		private router: Router
	) {}

	options = {
		headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
		withCredentials: true,
	};

	public getScrapingAccessToken(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getAccessTokenUrl, this.options)
			.pipe(
				catchError(
					this.handleError<Respuesta>(`GET -> getScrapingAccessToken`)
				)
			);
	}

	public getInternoAuthorizationToken(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getTokenInternoUrl, this.options)
			.pipe(
				catchError(
					this.handleError<Respuesta>(`GET -> getTokenInterno`)
				)
			);
	}

	public getSessionActive(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getSessionActiveUrl, this.options)
			.pipe(
				catchError(
					this.handleError<Respuesta>(`GET -> getSessionActiveUrl`)
				)
			);
	}

	public validateOtp(otp: string): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.validateOtpUrl, { otp }, this.options)
			.pipe(
				catchError(this.handleError<Respuesta>(`POST -> validateOtp`))
			);
	}

	public login(username: string, password: string): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.autenticarUsuarioUrl,
				{ username, password },
				this.options
			)
			.pipe(catchError(this.handleError<Respuesta>(`POST -> login`)));
	}
	public ingresar(
		username: string,
		password: string,
		perfil: Perfil
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.ingresarUrl,
				{ username, password, perfil },
				this.options
			)
			.pipe(catchError(this.handleError<Respuesta>(`POST -> ingresar`)));
	}

	public logMovimiento(
		accion: string,
		parametros: string
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.logMovimientoUrl,
				{ accion, parametros },
				this.options
			)
			.pipe(
				catchError(this.handleError<Respuesta>(`POST -> logMovimiento`))
			);
	}

	public reingresar(
		username: string,
		password: string,
		perfil: Perfil
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.reingresarUrl,
				{ username, password, perfil },
				this.options
			)
			.pipe(
				catchError(this.handleError<Respuesta>(`POST -> reingresar`))
			);
	}

	public getFirebaseAuth() {
		return this.http
			.post<Respuesta>(this.getFirebaseAuthUrl, null, this.options)
			.pipe(
				catchError(
					this.handleError<Respuesta>(`post -> getFirebaseAuth`)
				)
			);
	}

	public logout(): Observable<Respuesta> {
		// this.firebaseAuthService.Deauthenticate();
		// this.firebaseMessagingService.deleteToken();
		localStorage.removeItem('interno_token');
		return this.http
			.get<Respuesta>(this.cerrarSesionUrl, this.options)
			.pipe(catchError(this.handleError<Respuesta>(`GET -> logout`)));
	}

	public eliminarPerfil(): Observable<Respuesta> {
		this.currentUser.perfil = null;
		this.perfil = null;
		return this.http
			.get<Respuesta>(this.eliminarPerfilUrl, this.options)
			.pipe(
				catchError(this.handleError<Respuesta>(`GET -> eliminarPerfil`))
			);
	}

	public eliminarPerfilbyIdSession(idSession: string): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.eliminarPerfilbyIdSessionUrl,
				{ idSession },
				this.options
			)
			.pipe(
				catchError(
					this.handleError<Respuesta>(
						`POST -> eliminarPerfilbyIdSessionUrl`
					)
				)
			);
	}

	public esCambioDePerfil(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.esCambioDePerfilUrl, this.options)
			.pipe(
				catchError(
					this.handleError<Respuesta>(`GET -> esCambioDePerfil`)
				)
			);
	}

	public getDiccionarioAcciones(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getDiccionarioAccionesUrl, this.options)
			.pipe(
				catchError(
					this.handleError<Respuesta>(`GET -> getDiccionarioAcciones`)
				)
			);
	}

	public getDiccionarioVariablesLocales(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(
				this.getDiccionarioVariablesLocalesUrl,
				this.options
			)
			.pipe(
				catchError(
					this.handleError<Respuesta>(
						`GET -> getDiccionarioVariablesLocales`
					)
				)
			);
	}

	public obtenerUrlComparador(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.obtenerUrlComparadorUrl, this.options)
			.pipe(
				catchError(
					this.handleError<Respuesta>(`GET -> obtenerUrlComparador`)
				)
			);
	}

	public getIdiomas(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getIdiomasUrl, this.options)
			.pipe(catchError(this.handleError<Respuesta>(`GET -> getIdiomas`)));
	}
	public getAllActiveSessions(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getAllSessionsActiveUrl, this.options)
			.pipe(
				tap((res) => {
					this.checkResponseCodes(res);
				}),
				catchError(
					this.handleError<Respuesta>(
						`GET -> getAllSessionsActiveUrl`
					)
				)
			);
	}

	public getStrClientes(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getStrClientesUrl, this.options)
			.pipe(
				tap((res) => {
					this.checkResponseCodes(res);
				}),
				catchError(this.handleError<Respuesta>(`GET -> getStrClientes`))
			);
	}

	askYubi() {
		this.yubiEvent.next();
	}

	yubiWatch(): Observable<any> {
		return this.yubiEvent.asObservable();
	}

	public getCurrentUser(): User {
		return this.currentUser;
	}

	public setCurrentUser(currentUser: User) {
		this.currentUser = currentUser;
		this.perfil = currentUser.perfil;
		this.acciones = currentUser.perfil.tipoUsuario.acciones;
		let urlInicial = currentUser.perfil.tipoUsuario.urlInicial;
		if (urlInicial && urlInicial != '')
			this.establecerUrlInicial(urlInicial);
		else this.establecerUrlInicial('/app/inicio');

		this.urlRaiz = this.obtenerRutaRaiz(currentUser);
		this.registerCulture(currentUser.locale);
	}

	public getLastPerfil() {
		return this.perfil;
	}
	public setLastPerfil(perfil) {
		this.perfil = perfil;
	}
	public removeLastPerfil() {
		this.perfil = undefined;
	}
	public removeCurrentUser() {
		this.currentUser = undefined;
	}

	public getAcciones() {
		return this.acciones;
	}

	// public tienePermiso(codigo_accion:string):Boolean {
	//     console.log(this.diccAcciones);
	//     return false;
	// }

	public setDiccAcciones(data: any) {
		this.diccAcciones = data;
	}

	public getDiccAcciones() {
		return this.diccAcciones;
	}

	public obtenerUrlRaiz() {
		return this.urlRaiz;
	}

	public establecerUrlInicial(url: string) {
		this.urlInicial = url;
	}

	public obtenerUrlInicial() {
		return this.urlInicial;
	}

	public puedeAccederARuta(ruta: string) {
		if (!this.currentUser) return false;
		let rutaParseada: string = this.parsearRuta(ruta);
		if (
			!rutaParseada ||
			rutaParseada.trim() == '' ||
			this.esAccionDelSistema(rutaParseada)
		)
			return true;
		return !!this.obtenerAccionPorRuta(
			rutaParseada,
			this.currentUser.perfil.tipoUsuario.acciones
		);
	}

	/**
	 * Recorre el árbol de acciones y busca una ruta que coincida con la
	 * pasada por parámetro.
	 * @returns {any} Acción encontrada, undefined si no la encuentra.
	 */
	private obtenerAccionPorRuta(ruta: string, acciones: any[]) {
		for (let i = 0; i < acciones.length; i++) {
			let accion = acciones[i];
			if (this.parsearRuta(accion.ruta[0]) == ruta) return accion;

			if (accion.hijos && accion.hijos.length) {
				let resultado = this.obtenerAccionPorRuta(ruta, accion.hijos);
				if (resultado) return resultado;
			}
		}

		return undefined;
	}

	/**
	 * Quita los parámetros de la url pasada, y deja solo la última
	 * parte de la ruta. Ej: 'app/fotos/foto1?width=500' quedaría 'foto1'
	 * @param ruta Ruta a parsear
	 * @returns {string} string de la ruta parseada
	 */
	private parsearRuta(ruta: string): string {
		if (!ruta || ruta == '') return ruta;
		let rutaSinParametros: string = ruta.split('?')[0];
		let rutaPorNivel: string[] = rutaSinParametros.split('/');
		let accionDeRuta: string = rutaPorNivel[rutaPorNivel.length - 1];
		return accionDeRuta;
	}

	/**
	 * Retorna la ruta raiz especificada por Rol/TipoUsuario
	 * La ruta es /app por default
	 * @param usuario Usuario para obtener su ruta raiz
	 *
	 */
	private obtenerRutaRaiz(usuario: User): string {
		if (!usuario) return '/app';

		let urlInicial =
			usuario.perfil.tipoUsuario.urlInicial &&
			usuario.perfil.tipoUsuario.urlInicial != ''
				? usuario.perfil.tipoUsuario.urlInicial
				: '/app/inicio';

		if (!urlInicial || urlInicial == '') return '/app';

		let urlInicialSplit: string[] = urlInicial.split('/');
		if (urlInicialSplit[0] != '') return '/' + urlInicialSplit[0];

		// Por si hay una '/' al inicio de la url
		if (urlInicialSplit[0] == '' && urlInicialSplit[1] != '')
			return '/' + urlInicialSplit[1];

		return '/app';
	}

	private esAccionDelSistema(rutaAccion: string) {
		return !!ACCIONES_SISTEMA.find((accion) => accion == rutaAccion);
	}

	public obtenerAccion(acciones: any[], visitar: (accion: any) => boolean) {
		for (let i = 0; i < acciones.length; i++) {
			let accion = acciones[i];
			if (visitar(accion)) return accion;

			if (accion.hijos && accion.hijos.length) {
				let resultado = this.obtenerAccion(accion.hijos, visitar);
				if (resultado) return resultado;
			}
		}

		return undefined;
	}

	tienePermiso(codigoAccion: string) {
		if (!this.currentUser || !this.currentUser.perfil) return false;
		let accion = this.obtenerAccion(
			this.currentUser.perfil.tipoUsuario.acciones,
			(accion) => accion.accion == codigoAccion
		);
		return !!accion;
		// return this.currentUser.perfil.tipoUsuario.idsAccionesPantalla.includes(accion.idAccion);
	}

	nextHttpError(code: number) {
		this.httpErrorSubject.next(code);
	}
	getHttpErrors(): Observable<number> {
		return this.httpErrorSubject.asObservable();
	}

	checkResponseCodes(res: Respuesta, redireccionar: boolean = false) {
		if (!res.Succeed) {
			if (
				[
					//Codigos de error que desencadenan algun comportamiento especifico (dialog,toast,etc)
					401,
					403,
				].includes(res.Code)
			) {
				if (!this.currentUser || redireccionar) {
					this.router.navigate(['/login']);
				} else {
					this.nextHttpError(res.Code);
				}
			} else {
			}
		}
	}

	tokenExpiro(token: string) {
		if (!token || token.trim() == '') return true;
		const expiry = JSON.parse(atob(token.split('.')[1])).exp;
		return Math.floor(new Date().getTime() / 1000) >= expiry;
	}

	setScrapingAuthorizationVariable(token: string) {
		if (!token) return;
		localStorage.setItem('scraping_token', token);
	}

	getScrapingAuthorizationHeader() {
		const token: string = localStorage.getItem('scraping_token');
		if (!token) return null;
		return 'JWT ' + token;
	}

	setInternoAuthorizationToken(token: string) {
		if (!token) return;
		localStorage.setItem('interno_token', token);
	}

	getInternoAuthorizationHeader() {
		const token: string = localStorage.getItem('interno_token');
		if (!token) {
			return null;
		}
		if (token.trim() == '') {
			return null;
		}
		const expiry = JSON.parse(atob(token.split('.')[1])).exp;
		if (Math.floor(new Date().getTime() / 1000) >= expiry) {
			return null;
		}
		let payload = JSON.parse(atob(token.split('.')[1]));
		if (
			payload.idCliente != this.currentUser.perfil.cliente.idCliente ||
			payload.idUsuario != this.currentUser.id_usuario
		) {
			return null;
		}
		return '' + token;
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<Respuesta> => {
			// TODO: send the error to remote logging infrastructure
			console.error(error); // log to console instead

			// TODO: better job of transforming error for user consumption
			console.log(`${operation} failed: ${error.message}`);

			// Let the app keep running by returning an empty result.
			return of(new Respuesta());
		};
	}

	private _locale: string;

	set locale(value: string) {
		this._locale = value;
	}
	get locale(): string {
		return this._locale || 'es-AR';
	}

	registerCulture(culture: string) {
		if (!culture) {
			return;
		}
		this.locale = culture;
		if (culture.includes('fr')) registerLocaleData(localeFr);
		if (culture.includes('pt')) registerLocaleData(localePt);
		if (culture.includes('en')) registerLocaleData(localeEn);
		if (culture.includes('es')) registerLocaleData(localeEs);
	}
}
